import React from 'react';
import PropTypes from 'prop-types';

import './Style.css';

const rnd = Math.floor(Math.random() * 5);

/* eslint-disable global-require, import/no-dynamic-require */
const image = require(`./images/${rnd + 1}.jpg`);
/* eslint-enable global-require, import/no-dynamic-require  */

const Header = props => (
  <div className={`Header${props.isSmaller ? ' smaller' : ''}`} >
    <img src={image} alt="background" />
  </div>
);

Header.propTypes = {
  isSmaller: PropTypes.bool.isRequired,
};

export default Header;



// WEBPACK FOOTER //
// ./src/template/header/View.js